import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { scheduleUpcomingSearchSchema, SchedulesUpcomingPage } from '@/features/schedules';

export const Route = createFileRoute('/_authed/_active/org/schedules/upcoming')({
  staticData: { crumb: 'schedules:nav.upcoming' },
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) =>
    scheduleUpcomingSearchSchema.parse(search),
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'products.read');
  },
  component: SchedulesUpcomingPage,
});
